module.exports = __webpack_public_path__ + "static/media/warning.85d08b87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/warning.svg
// module id = 860
// module chunks = 0